var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"maintenance_alert",attrs:{"close-text":"Close Alert","color":"primarybutton","dark":"","dismissible":""},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_c('maintenance-message')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }